<script>
  import { SIGN_UP_STEPS } from '@/helpers/enums';
  import { GameLauncher } from '@/mixins/game-launcher';
  import { CURRENCIES } from '@/store';

  export default {
    name: 'SignUpCongrats',

    mixins: [GameLauncher],

    data: () => ({
      banners: [
        {
          src: '/images/banners/MQ-SignUp-Banner-MultiPlinko.webp?v=1',
          title: 'Multi Plinko',
          image: '/images/cards/hp/pvp-mp.webp?v=1',
          category: 'PVP',
          redirect: 'multiplinko',
          gameType: 'plinko',
        },
      ],
    }),

    computed: {
      randomBanner() {
        const randomIndex = Math.floor(Math.random() * this.banners.length);
        return this.banners[randomIndex];
      },

      freeMcAmount() {
        return 5;
      },
    },

    methods: {
      closeModal() {
        // force set currency to QC to enable free play mode
        this.$store.dispatch('setPlayMode', { mode: CURRENCIES.MQC });
        localStorage.setItem('setCurrencyToMc', 'true');

        this.handleGameClick(this.randomBanner);
        this.$store.dispatch('changeSignupStep', SIGN_UP_STEPS.CREDENTIALS);
        this.$store.dispatch('changeSignupDialogState', false);
      },
    },
  };
</script>

<template>
  <div class="d-flex flex-column align-center mt-6 white--text">
    <span class="font-weight-600 font-size-40 reward-text">You earned 10,000 QC</span>

    <span class="text-center mt-4 currency-text">
      Questcoin
      <span>(</span>
      <span class="gold--text">QC</span>
      <span>)</span>
      cannot be exchanged for real money and can only be used to play the games for free.
    </span>

    <img class="mt-6 cursor-pointer" :src="randomBanner.src" alt="banner" @click="closeModal()" />
  </div>
</template>

<style scoped lang="scss">
  .reward-text {
    line-height: 48px;
    text-align: center;
  }

  .currency-text {
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
  }

  .banner {
  }
</style>
